<div
    class="render-cell"
    [ngClass]="{ 'text-center': stretched || width <= 300 }"
    [title]="showTooltip && row[header] ? row[header] : ''"
    [ngStyle]="{ width: width + 'px' }"
>
    @if (renderer && renderer.type !== rendererTypes.Default) {
        @switch (renderer.type) {
            @case (rendererTypes.DueDate) {
                <!-- Overdue renderer -->
                <div #overDueElement class="padded-cell">
                    {{ overDueRender(row[header], renderer, overDueElement) }}
                </div>
            }
            @case (rendererTypes.Score) {
                @if (row[renderer.actionColumn]) {
                    <!-- Score renderer -->
                    <div class="score-renderer">
                        <div
                            class="score-indication"
                            [ngStyle]="{
                                background:
                                    (row[renderer.actionColumn][0] == '#' ? '' : '#') +
                                    row[renderer.actionColumn],
                            }"
                        ></div>
                        <div class="score-value padded-cell">
                            {{ defaultRender(row[header], renderer) }}
                        </div>
                    </div>
                }
            }
            @case (rendererTypes.Progress) {
                <!-- Progress renderer -->
                <div class="padded-cell" [title]="row[header] + '%'">
                    <div class="progress">
                        <div
                            class="progress-bar progress-bar"
                            role="progressbar"
                            attr.aria-valuenow="{{ row[header] }}"
                            aria-valuemin="0"
                            aria-valuemax="100"
                            [ngStyle]="{ width: row[header] + '%' }"
                        ></div>
                    </div>
                </div>
            }
            @case (rendererTypes.Icon) {
                @if (renderer.extraValue && row[renderer.actionColumn] === renderer.actionValue) {
                    <!-- Icon renderer with specific icon -->
                    <div class="padded-cell">
                        <div class="icon">
                            <cerrix-icon-viewer [icon]="renderer.extraValue"></cerrix-icon-viewer>
                        </div>
                    </div>
                }
                @if (!renderer.extraValue) {
                    <!-- Icon renderer -->
                    <div class="padded-cell">
                        <div class="icon">
                            <cerrix-icon-viewer [icon]="row[header]"></cerrix-icon-viewer>
                        </div>
                    </div>
                }
            }
        }
    } @else {
        <!-- No renderer -->
        <div class="padded-cell">
            {{ defaultRender(row[header], renderer) }}
        </div>
    }
</div>
